module.exports = __webpack_public_path__ + "img/logo.fdd0a371.svg";